module.exports = __webpack_public_path__ + "static/media/tti_reason_2.0d3f328a.png";